export default "__VITE_ASSET__CWBuZnye__"